import { ApplicationsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  GetApplicationPhasesDocument,
  JobPostingDocument,
  RejectApplicationsDocument,
  RejectApplicationsMutation,
  RejectApplicationsMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useRejectApplications = () => {
  const [rejectMutation, { loading }] = useMutation(RejectApplicationsDocument, {
    extractorFn: (data: RejectApplicationsMutation) =>
      data.atsMutations.bulkDisqualifyAtsApplication,
  })

  return {
    loading,
    rejectApplications(variables: RejectApplicationsMutationVariables) {
      return rejectMutation({
        variables,
        refetchQueries: [
          ApplicationsDataTableDocument,
          JobPostingDocument,
          GetApplicationPhasesDocument,
        ],
        awaitRefetchQueries: true,
      })
    },
  }
}
